export default __webpack_public_path__ + "static/media/patterns-no-4.8a06cc3a.ogg";